import { render, staticRenderFns } from "./material-store.vue?vue&type=template&id=bfd1b7da&scoped=true&"
import script from "./material-store.vue?vue&type=script&lang=js&"
export * from "./material-store.vue?vue&type=script&lang=js&"
import style0 from "./material-store.vue?vue&type=style&index=0&id=bfd1b7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd1b7da",
  null
  
)

export default component.exports